/**
 * 客户物料指定供应商 - 常量定义
 * @module types/customer-material-supplier
 */

import { DesignationType, CustomerMaterialSupplierStatus } from './enums';

/**
 * 指定类型选项
 */
export const DESIGNATION_TYPE_OPTIONS = [
  { label: '推荐', value: DesignationType.RECOMMENDED, color: 'blue' },
  { label: '指定', value: DesignationType.DESIGNATED, color: 'orange' },
  { label: '独家', value: DesignationType.EXCLUSIVE, color: 'red' },
] as const;

/**
 * 指定类型文本映射
 */
export const DESIGNATION_TYPE_TEXT_MAP: Record<DesignationType, string> = {
  [DesignationType.RECOMMENDED]: '推荐',
  [DesignationType.DESIGNATED]: '指定',
  [DesignationType.EXCLUSIVE]: '独家',
};

/**
 * 客户物料指定供应商状态选项
 */
export const CUSTOMER_MATERIAL_SUPPLIER_STATUS_OPTIONS = [
  { label: '禁用', value: CustomerMaterialSupplierStatus.DISABLED },
  { label: '启用', value: CustomerMaterialSupplierStatus.ENABLED },
] as const;

/**
 * 客户物料指定供应商状态文本映射
 */
export const CUSTOMER_MATERIAL_SUPPLIER_STATUS_TEXT_MAP: Record<CustomerMaterialSupplierStatus, string> = {
  [CustomerMaterialSupplierStatus.DISABLED]: '禁用',
  [CustomerMaterialSupplierStatus.ENABLED]: '启用',
};

/**
 * 默认优先级
 */
export const DEFAULT_PRIORITY = 100;

/**
 * 优先级范围
 */
export const PRIORITY_RANGE = {
  min: 1,
  max: 999,
} as const;
